import React, { useState } from 'react'
import { InputNumber, Button, Form, Modal, Select, Switch } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons';

import { CREDIT_TERMS } from "../../constants/billing";
import { PERMISSIONS } from "../../constants/roles";
import { usePermissions } from "../App/PermissionContext";

const BillingSettings = ({ settings, onSave }) => {
  const { permissions } = usePermissions();

  const [saving, setSaving] = useState(false)
  const [form] = Form.useForm();

  const saveHandler = async (newSettings) => {
    setSaving(true)

    Modal.confirm({
      title: 'Confirm to update the billing settings?',
      icon: <ExclamationCircleOutlined />,
      onOk() {
        onSave('billing', newSettings).then(() => {
          form.resetFields()
          setSaving(false)
        })
      },
      onCancel() {
        setSaving(false)
      },
    });
  }

  return (
    <div>
      <Form
        form={form}
        name="billing-settings"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        autoComplete="off"
        initialValues={settings}
        requiredMark={false}
        onFinish={saveHandler}
      >
        <Form.Item
          extra={`Applied to a merchant's Billing Statement when they have no per-merchant credit term override set`}
          label="Default Credit Term:"
          name="defaultCreditTerm"
          rules={[{ required: true, message: 'Please select the default credit term!' }]}
        >
          <Select disabled={!permissions?.includes(PERMISSIONS.UPDATE_SETTING)}>
            {CREDIT_TERMS.map((term) => (
              <Select.Option key={term} value={term}>{term} days</Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          extra={`Number of days after issuance a Debit Note becomes due -- applies to all Debit Notes, no per-merchant override`}
          label="Default Debit Note Due Days:"
          name="debitNoteDueDays"
          rules={[{ required: true, message: 'Please input the number of days!' }]}
        >
          <InputNumber disabled={!permissions?.includes(PERMISSIONS.UPDATE_SETTING)} min={1} step={1} />
        </Form.Item>

        <Form.Item
          extra="While on, only the admin-tester account can see the new Billing page. Turn off once validated for production."
          label="Restrict Billing Page to Test Account:"
          name="testingGateEnabled"
          valuePropName="checked"
          initialValue={settings?.testingGateEnabled !== false}
        >
          <Switch disabled={!permissions?.includes(PERMISSIONS.UPDATE_SETTING)} />
        </Form.Item>

        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
          <Button disabled={!permissions?.includes(PERMISSIONS.UPDATE_SETTING)} type="primary" loading={saving} htmlType="submit">Save</Button>
        </Form.Item>
      </Form>
    </div>
  )
}

export default BillingSettings
